import { render, staticRenderFns } from "./BodegaReporteCodigosLiquidadosContratos.vue?vue&type=template&id=521ec453"
import script from "./BodegaReporteCodigosLiquidadosContratos.vue?vue&type=script&lang=js"
export * from "./BodegaReporteCodigosLiquidadosContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports